import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '../components/pages/authentication/authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class ChartService {
  private url = environment.api;
  private companyID = 0;
  constructor(
    private http: HttpClient,
    private authService: AuthenticationService
  ) { 
    this.companyID = parseInt(this.authService.getCurrentCompanyId());
  }


  getAccountingResultChart(year:number){
    return this.http.get(this.url + 'api/erp/accounting/report/graph/landing/incomevsexpenses/'+this.companyID+'/'+year)
  }
  // https://app.dev.servicios.gt/
  
  getAccountingBalanceChart(year:number){
    return this.http.get(this.url + 'api/erp/accounting/report/graph/landing/general/balance/'+this.companyID+'/'+year)
  }
  
  getExpensesChart(year:number){
    return this.http.get(this.url + 'api/erp/accounting/report/graph/landing/expenses/'+this.companyID+'/'+year)
  }

  getProfitVsCosts(year:number){
    return this.http.get(this.url + 'api/erp/accounting/report/graph/landing/income/'+this.companyID+'/'+year)
  }
  
}
